export const optimizationEventOpens = "opens" as const;
export const optimizationEventClicks = "clicks" as const;
export const optimizationEventReads = "reads" as const;
export const optimizationEventLinkClicks = "link_clicks" as const;

export const eventToBehavior = {
  opens: "TrackedUserBehavior::CanvasOpen",
  clicks: "TrackedUserBehavior::CanvasClick",
  reads: "TrackedUserBehavior::CanvasOpen",
  link_clicks: "TrackedUserBehavior::CanvasClick",
} as const;

/** Default conversion window of 24 hours in seconds */
export const defaultConversionWindowSeconds = 86400;
